import { PortableText, PortableTextComponents } from '@portabletext/react'
import { useRouter } from 'next/router'

import Metatags from '~/components/Metadata/Metatags'
import { useGetFaqsQuery } from '~/redux/apis/static-page-api'
import { DefaultLayout } from '~/shared/layouts'
import FAQItem from '~/start/components/FAQItem'
import FaqAnswerLink from '~/static-pages/faq/components/FaqAnswerLink'
import SanityStaticPage from '~/static-pages/SanityStaticPage.page'
import { AppLanguage } from '~/types/locale'

interface AnswerBlock {
  _type: string
  _key?: string
}

const answerComponents: PortableTextComponents = { marks: { link: FaqAnswerLink } }

export default function Faq(): React.ReactElement {
  const language = useRouter().locale as AppLanguage
  const { data } = useGetFaqsQuery({ language })
  const faqs = data?.faqs ?? []

  if (!data) return <></>
  if (faqs.length === 0) return <SanityStaticPage />

  const { content, header, metaDescription, title } = data
  const intro = Array.isArray(content) ? (content as AnswerBlock[]) : []

  return (
    <DefaultLayout zeroPadding>
      <Metatags metaDescription={metaDescription} title={title} />
      <div className="mx-auto flex w-full max-w-232 flex-col gap-8 p-4 pb-8 pt-12 text-white xl:pt-16">
        <h1 className="text-center text-h2 font-bold uppercase leading-14.5">{header}</h1>
        {intro.length > 0 && (
          <div className="mx-auto flex max-w-4xl flex-col gap-4 whitespace-pre-line text-center text-md text-blue-pastel">
            <PortableText components={answerComponents} value={intro} />
          </div>
        )}
        <div className="flex flex-col gap-4">
          {faqs.map(({ answer, key, question }) => (
            <FAQItem
              answer={
                <div className="flex flex-col gap-4 break-words">
                  <PortableText components={answerComponents} value={answer as AnswerBlock[]} />
                </div>
              }
              key={key}
              question={question}
            />
          ))}
        </div>
      </div>
    </DefaultLayout>
  )
}
